import type { SelectOption } from "@/components/filter-popover";
import type { Opportunity } from "@/hooks/api/use-account-opportunities";
import { formatDate } from "@/lib/date-formatting";
import type { UnifiedTableColumn } from "@/types/table-column";

// Filter options for opportunity types
export const opportunityTypeFilterOptions: SelectOption[] = [
  { id: "New Business", label: "New Business" },
  { id: "Renewal", label: "Renewal" },
  { id: "Expansion", label: "Expansion" },
];

// Filter options for opportunity stages (common ones)
export const opportunityStageFilterOptions: SelectOption[] = [
  { id: "Qualification", label: "Qualification" },
  { id: "Discovery", label: "Discovery" },
  { id: "Proposal", label: "Proposal" },
  { id: "Negotiation", label: "Negotiation" },
  { id: "Closed Won", label: "Closed Won" },
  { id: "Closed Lost", label: "Closed Lost" },
];

/**
 * Column definitions for the Opportunities table in the custom buying group modal
 */
export const getOpportunityColumns = (): UnifiedTableColumn<Opportunity>[] => {
  return [
    {
      key: "name",
      title: "Name",
      sortable: true,
      filterable: true,
      filterType: "text",
    },
    {
      key: "stage_name",
      title: "Stage",
      sortable: true,
      filterable: true,
      filterType: "select",
      filterOptions: opportunityStageFilterOptions,
    },
    {
      key: "type",
      title: "Type",
      sortable: true,
      filterable: true,
      filterType: "select",
      filterOptions: opportunityTypeFilterOptions,
    },
    {
      key: "created_date",
      title: "Created",
      sortable: true,
      filterable: true,
      filterType: "date",
      render: (opportunity) =>
        opportunity.created_date ? formatDate(opportunity.created_date) : "-",
    },
    {
      key: "close_date",
      title: "Close date",
      sortable: true,
      filterable: true,
      filterType: "date",
      render: (opportunity) =>
        opportunity.close_date ? formatDate(opportunity.close_date) : "-",
    },
  ];
};

/**
 * Factory function to create a unique key extractor for opportunities
 */
export const opportunityKeyExtractor = (opportunity: Opportunity): string =>
  opportunity.id;
